<ag-mail
  [model]="'enterprise'"
  [referenceId]="companyId"
  (send)="openMail($event)"
></ag-mail>
